import React, { useState } from "react";

import Popover from "@mui/material/Popover";

import { ButtonVariant } from "Constant/button";

import { MenuRow, popoverMenuPaperSx } from "components/atoms/PopoverMenu";
import StandartButton from "components/atoms/StandartButton";

import { GenericTableActionButton } from "./GenericTable.types";

type TableToolbarActionButtonProps = {
    action: GenericTableActionButton;
};

const toolbarButtonSx = {
    height: 32,
    minHeight: 32,
    py: 0,
    lineHeight: 1.2,
    "& .MuiButton-startIcon": {
        marginRight: "6px",
        "& > *:nth-of-type(1)": {
            fontSize: 18,
        },
    },
};

const TableToolbarActionButton = ({ action }: TableToolbarActionButtonProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const hasChildren =
        Array.isArray(action.children) && action.children.length > 0;
    const variant = action.variant || ButtonVariant.BLACK_OUTLINED;

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (!hasChildren) {
        return (
            <StandartButton
                variant={variant}
                size="small"
                disabled={action.disabled}
                isLoading={action.isLoading}
                startIcon={action.icon}
                onClick={action.onClick}
                sx={toolbarButtonSx}
            >
                {action.name}
            </StandartButton>
        );
    }

    return (
        <>
            <StandartButton
                variant={variant}
                size="small"
                disabled={action.disabled}
                isLoading={action.isLoading}
                startIcon={action.icon}
                onClick={handleOpen}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                sx={toolbarButtonSx}
            >
                {action.name}
            </StandartButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                slotProps={{
                    paper: {
                        sx: popoverMenuPaperSx,
                    },
                }}
                disableRestoreFocus
                disableScrollLock
            >
                {action.children!.map((child, index) => {
                    const isLast = index === action.children!.length - 1;
                    return (
                        <MenuRow
                            key={child.key || `${child.name}-${index}`}
                            icon={child.icon ?? null}
                            label={child.name}
                            danger={child.danger}
                            isLast={isLast}
                            onClick={() => {
                                if (child.disabled) return;
                                handleClose();
                                child.onClick?.();
                            }}
                        />
                    );
                })}
            </Popover>
        </>
    );
};

export default TableToolbarActionButton;
